import { render, staticRenderFns } from "./GraphicsTypographicSection.vue?vue&type=template&id=1d60dd3e"
import script from "./GraphicsTypographicSection.vue?vue&type=script&lang=ts"
export * from "./GraphicsTypographicSection.vue?vue&type=script&lang=ts"
import style0 from "./GraphicsTypographicSection.vue?vue&type=style&index=0&id=1d60dd3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports